import React, { useContext } from "react";
import { Dialog, DialogContent, Box, Typography, IconButton, Snackbar, Alert, Slide, Button } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import ErrorIcon from "@mui/icons-material/Error";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { SnackBarContext } from "../../Context/SnackBarContext/SnackBarContext";
import { useNavigate } from "react-router-dom";

function SlideTransition(props) {
  return <Slide {...props} direction="left" />;
}

function SnackBar() {
  const { snackBarData, setsnackBarData } = useContext(SnackBarContext);
  const navigate = useNavigate();

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setsnackBarData({
      type: "",
      message: "",
      openToast: false,
      viewDetail: null,
    });
  };

  const handleCloseDialog = () => {
    setsnackBarData(prev => ({ ...prev, openToast: false }));
  };

  const getDialogContent = () => {
    switch (snackBarData?.type) {
      case "warning":
        return {
          icon: <WarningAmberIcon sx={{ fontSize: 44, color: "#ff9800" }} />,
          title: "Warning",
          color: "#ff9800",
          bgColor: "#fff4e5",
        };
      case "error":
        return {
          icon: <ErrorIcon sx={{ fontSize: 44, color: "#f44336" }} />,
          title: "Error",
          color: "#f44336",
          bgColor: "#fdecea",
        };
      default:
        return {
          icon: <ErrorIcon sx={{ fontSize: 44, color: "#607d8b" }} />,
          title: "Info",
          color: "#607d8b",
          bgColor: "#eceff1",
        };
    }
  };

  const { icon, title, color, bgColor } = getDialogContent();

  return (
    <>
      {snackBarData?.type === "success" || snackBarData?.alert ? (
        <Snackbar
          open={snackBarData?.openToast}
          autoHideDuration={4000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          TransitionComponent={SlideTransition}
        >
          <Alert
            onClose={handleClose}
            severity={snackBarData?.type || "info"}
            variant="filled"
            sx={{ width: "100%", minWidth: "250px" }}
          >
            {snackBarData?.message}
          </Alert>
        </Snackbar>
      ) : (
        <Dialog
          open={snackBarData?.openToast || false}
          onClose={handleClose}
          PaperProps={{
            sx: {
              borderRadius: "20px",
              width: "360px",
              textAlign: "center",
              boxShadow: "0 20px 40px -10px rgba(0,0,0,0.15)",
              overflow: "hidden",
            },
          }}
        >
          <IconButton
            onClick={e => {
              e.stopPropagation();
              handleCloseDialog();
            }}
            sx={{
              position: "absolute",
              top: 12,
              right: 12,
              color: "#999",
              transition: "all 0.2s",
              "&:hover": {
                color: "#333",
                backgroundColor: "rgba(0,0,0,0.04)"
              }
            }}
          >
            <HighlightOffIcon sx={{ fontSize: "24px" }} />
          </IconButton>

          <DialogContent sx={{ p: 4, pt: 5 }}>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              gap={2}
            >
              {/* Premium Icon Container */}
              <Box
                sx={{
                  width: 72,
                  height: 72,
                  borderRadius: "50%",
                  backgroundColor: bgColor,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mb: 1,
                }}
              >
                {icon}
              </Box>

              <Typography variant="h5" sx={{ fontWeight: 700, color: "#1a1a1a", letterSpacing: "-0.5px" }}>
                {title}
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  color: "#666",
                  wordBreak: "break-word",
                  lineHeight: 1.5,
                  mb: snackBarData?.viewDetail ? 1 : 2,
                }}
              >
                {snackBarData?.message || "Something went wrong."}
              </Typography>

              {snackBarData?.viewDetail && (
                <Button
                  variant="outlined"
                  size="small"
                  onClick={() => {
                    handleClose(null, "close");
                    navigate("/leads/view", {
                      state: snackBarData?.viewDetail,
                    });
                  }}
                  sx={{
                    borderRadius: "8px",
                    textTransform: "none",
                    fontWeight: 600,
                    color: color,
                    borderColor: color,
                    "&:hover": {
                      backgroundColor: bgColor,
                      borderColor: color,
                    }
                  }}
                >
                  View Lead Details
                </Button>
              )}
            </Box>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}

export default SnackBar;

